import { render } from "./CreateInstitution.vue?vue&type=template&id=724bc704"
import script from "./CreateInstitution.vue?vue&type=script&lang=js"
export * from "./CreateInstitution.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__